/**
 * Truncates a string at the supplied maxLength and adds an ellipses if it exceeds it.
 */
export const truncateText = (text: string, maxLength: number) =>
  text.length > maxLength ? `${text.slice(0, maxLength).trim()}...` : text;
